import axios from "axios";
import { showToast } from "./CoreDataService";

const apiRequest = async (
  url,
  method = "GET",
  payload = null,
  requiresAuth = true,
  options = {}
) => {
  try {
    const defaultHeaders = {
      "Content-Type": "application/json",
      ...options.headers,
    };

    // Add authorization header only if requiresAuth is true
    if (requiresAuth) {
      const token = localStorage.getItem("access_token");
      if (token) {
        defaultHeaders.authorization = `BEARER ${token}`;
      }
    }

    // Configure axios request
    const config = {
      url,
      method: method.toUpperCase(),
      headers: defaultHeaders,
      ...options,
    };

    // Add payload for methods that support request body
    if (["POST", "PUT", "PATCH"].includes(method.toUpperCase()) && payload) {
      config.data = JSON.stringify(payload);
    }

    // Add query parameters for GET requests
    if (method.toUpperCase() === "GET" && payload) {
      config.params = payload;
    }

    // Execute the request
    const response = await axios(config);
    const result = response.data;

    // Handle API response based on error_data
    if (result.error && result.error.error_data !== undefined) {
      if (result.error.error_data === 0) {
        // Success case
        if (result.error.error_msg) {
          showToast("success", result.error.error_msg);
        }
        return result;
      } else if (result.error.error_data === 1) {
        // Error case
        showToast("error", result.error.error_msg || "An error occurred");
        // throw new Error(result.error.error_msg || "API Error");
      } else {
        // Warning case
        showToast("warning", result.error.error_msg || "Warning occurred");
        return result;
      }
    }

    // If no error structure, return the result
    return result;
  } catch (error) {
    // Handle different types of errors
    if (error.response) {
      // Server responded with error status
      const status = error.response.status;
      const statusText = error.response.statusText;

      switch (status) {
        case 400:
          showToast("error", "Bad Request: Please check your input data");
          break;
        case 401:
          showToast("error", "Unauthorized: Please login again");
          // Optionally redirect to login
          // window.location.href = '/login';
          break;
        case 403:
          showToast(
            "error",
            "Forbidden: You don't have permission to perform this action"
          );
          break;
        case 404:
          showToast("error", "Not Found: The requested resource was not found");
          break;
        case 408:
          showToast("error", "Request Timeout: Please try again");
          break;
        case 429:
          showToast(
            "error",
            "Too Many Requests: Please wait before trying again"
          );
          break;
        case 500:
          showToast("error", "Internal Server Error: Please try again later");
          break;
        case 502:
          showToast("error", "Bad Gateway: Service temporarily unavailable");
          break;
        case 503:
          showToast("error", "Service Unavailable: Please try again later");
          break;
        default:
          showToast("error", `Server Error (${status}): ${statusText}`);
      }
    } else if (error.request) {
      // Network error or no response received
      showToast(
        "error",
        "Network Error: Please check your internet connection"
      );
    } else if (error.code === "ECONNABORTED") {
      // Request timeout
      showToast("error", "Request Timeout: Please try again");
    } else {
      // Other errors (including API errors we threw above)
      showToast("error", error.message || "An unexpected error occurred");
    }

    // Re-throw the error for further handling if needed
    throw error;
  }
};
export default apiRequest;
